import apiClient from '../../lib/axios';

/**
 * Get all active users (no pagination).
 * Uses GET /api/users/active - same shape as fetchUsers: { data: { users, count } }.
 */
export const fetchActiveUsers = async () => {
  const response = await apiClient.get('/api/users/active');
  return response.data;
};

export const fetchUsers = async (filters = {}) => {
  const params = new URLSearchParams();
  const normalized = { ...filters };
  if (normalized.pageSize && !normalized.limit) normalized.limit = normalized.pageSize;
  if (filters.isActive !== undefined) params.append('isActive', filters.isActive);
  if (filters.search) params.append('search', filters.search);
  if (filters.page) params.append('page', filters.page);
  if (normalized.limit) params.append('limit', normalized.limit);
  if (filters.sortBy) params.append('sortBy', filters.sortBy);
  if (filters.sortOrder) params.append('sortOrder', filters.sortOrder);
  if (filters.branch) params.append('branch', filters.branch);
  if (filters.gender) params.append('gender', filters.gender);
  if (filters.directorate) params.append('directorate', filters.directorate);
  if (filters.position) params.append('position', filters.position);
  const response = await apiClient.get(`/api/users?${params.toString()}`);
  return response.data;
};

/**
 * Get a single user by ID.
 * GET /api/users/:id - returns { data: { user } }.
 */
export const fetchUserById = async (id) => {
  if (!id) return null;
  const response = await apiClient.get(`/api/users/${id}`);
  return response.data?.data?.user ?? null;
};

export const createUser = async (payload) => {
  const response = await apiClient.post('/api/users', payload);
  return response.data;
};

export const updateUser = async ({ id, payload }) => {
  const response = await apiClient.patch(`/api/users/${id}`, payload);
  return response.data;
};

export const deleteUser = async (id) => {
  const response = await apiClient.delete(`/api/users/${id}`);
  return response.data;
};

export const resetUserPassword = async (id) => {
  const response = await apiClient.post(`/api/users/${id}/reset-password`);
  return response.data;
};

export const updateUserProfile = async ({ userId, payload }) => {
  const response = await apiClient.patch(`/api/user-profiles/${userId}`, payload);
  return response.data;
};

export const bulkUploadUsers = async ({ rows, updateExisting = true, dryRun = false } = {}) => {
  const response = await apiClient.post('/api/users/bulk-upload', {
    rows,
    updateExisting,
    dryRun,
  });
  return response.data;
};

export default fetchUsers;
